import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { lastValueFrom, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { Compromiso } from '../models/compromiso.model';

@Injectable({
  providedIn: 'root',
})
export class CompromisoService {
  constructor(private httpClient: HttpClient) {}

  public getCompromisos(
    option: number | null,
  ): Observable<{ commitments: Compromiso[] }> {
    let params = new HttpParams();

    switch (option) {
      case 1:
        params = params.set('appliesTo', 'Aplicaciones');
        params = params.set('community', 'Fibras');
        break;
      case 2:
        // Personas o Empresas
        params = params.set('community', 'Fibras');
        break;
      default:
        break;
    }

    return this.httpClient
      .get<{
        commitments: any;
      }>(environment.api_fibras + 'commitments', { params })
      .pipe(
        map(response => ({
          commitments: response.commitments
            ? response.commitments
                .filter((c: any) => c.enabled)
                .sort(
                  (a: { title: string }, b: { title: any }) =>
                    a.title
                      .normalize('NFD')
                      .replace(/[\u0300-\u036f]/g, '')
                      .localeCompare(
                        b.title
                          .normalize('NFD')
                          .replace(/[\u0300-\u036f]/g, ''),
                        'es',
                      ),
                )
            : [],
        })),
      );
  }

  public async getCompromisosPorComunidad(communityName: string) {
    let params = new HttpParams();
    params = params.set('community', communityName);
    return lastValueFrom(
      this.httpClient
        .get<{
          commitments: any;
        }>(environment.api_fibras + 'commitments', { params })
        .pipe(
          map(response => ({
            commitments: response.commitments
              ? response.commitments
                  .filter((c: any) => c.enabled)
                  .sort(
                    (a: { title: string }, b: { title: any }) =>
                      a.title
                        .normalize('NFD')
                        .replace(/[\u0300-\u036f]/g, '')
                        .localeCompare(
                          b.title
                            .normalize('NFD')
                            .replace(/[\u0300-\u036f]/g, ''),
                          'es',
                        ),
                  )
              : [],
          })),
        ),
    );
  }

  public getCompromiso(code: string): Observable<{ compromiso: Compromiso[] }> {
    let params = new HttpParams();
    params = params.set('code', code);
    return this.httpClient.get<{ compromiso: Compromiso[] }>(
      environment.api_fibras + 'commitments',
      { params },
    );
  }

  private getAdherence(commitmentCode: string): Observable<any> {
    return this.httpClient.get<any>(
      environment.api_fibras + `commitments/${commitmentCode}/adherence`,
    );
  }

  public async getMembersPorCompromiso(
    communityName: string,
    code: string,
  ): Promise<any> {
    try {
      const adherence = await lastValueFrom(this.getAdherence(code));
      return { adherence };
    } catch (error) {
      console.error('Error fetching adherence data:', error);
      return { adherence: [] };
    }
  }

  public getDocumentDetails(documentId: string): Observable<{
    id: number;
    name: string;
    url: string;
    hash: string;
  }> {
    return this.httpClient.get<{
      id: number;
      name: string;
      url: string;
      hash: string;
    }>(environment.api_storage_sincronia + `file/${documentId}`);
  }
}
